import React, { useEffect, useState } from "react";
import NewTitle from "../../extra/Title";
import { useTabSelectWithClearSearch } from "../../../util/useTabSelectWithClearSearch";
import AdminEarnings from "./AdminEarnings";
import CoinPlanEarnings from "./CoinPlanEarnings";
import AllPlanEarnings from "./AllPlanEarnings";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { getPlanStatsData } from "../../store/coinPlan/coinPlan.action";
import StatsCards from "../../extra/StatsCards";
import {
  IconCoin,
  IconCoins,
  IconCash,
  IconCashBanknote,
  IconPremiumRights,
  IconAward,
  IconCurrencyDollar,
  IconWallet,
} from "@tabler/icons-react";

const EARNINGS_TAB_LABELS = ["All Plan", "Coin Plan", "Premium Plan"];

const getInitialEarningsTab = () => {
  try {
    const raw = sessionStorage.getItem("multiButton");
    if (!raw) return "All Plan";
    const parsed = JSON.parse(raw);
    if (EARNINGS_TAB_LABELS.includes(parsed)) return parsed;
  } catch {
    /* ignore */
  }
  return "All Plan";
};

const MainEarnings = () => {
  const dispatch = useDispatch();
  const { multiButtonSelect, setMultiButtonSelect, handleMultiButtonSelect } =
    useTabSelectWithClearSearch(getInitialEarningsTab);
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");
  const { planStatsData } = useSelector((state) => state.coinPlan);

  const startDateFormat = (startDateValue) => {
    return startDateValue && dayjs(startDateValue).isValid()
      ? dayjs(startDateValue).format("YYYY-MM-DD")
      : "All";
  };

  const endDateFormat = (endDateValue) => {
    return endDateValue && dayjs(endDateValue).isValid()
      ? dayjs(endDateValue).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  useEffect(() => {
    dispatch(getPlanStatsData(startDateData, endDateData));
  }, [dispatch, startDateData, endDateData]);

  const statsCards = [

    {
      title: "Coin Plan Sold",
      count: planStatsData?.coinPlanSold,
      Icon: IconCoins,
    },
    {
      title: "Earning From Coin Plan",
      count: planStatsData?.earningFromCoinPlanPurchase,
      Icon: IconCashBanknote,
    },
    {
      title: "Premium Plan Sold",
      count: planStatsData?.premiumPlanSold,
      Icon: IconAward,
    },
    {
      title: "Earning From Premium Plan",
      count: planStatsData?.earningFromPremiumPlanPurchase,
      Icon: IconWallet,
    },
    {
      title: "Coin Plan Sold Today",
      count: planStatsData?.coinPlanSoldToday,
      Icon: IconCoin,
    },
 
    {
      title: "Earning From Coin Plan Today",
      count: planStatsData?.earningFromCoinPlanPurchaseToday,
      Icon: IconCash,
    },
  
    {
      title: "Premium Plan Sold Today",
      count: planStatsData?.premiumPlanSoldToday,
      Icon: IconPremiumRights,
    },
    
    {
      title: "Earning From Premium Plan Today",
      count: planStatsData?.earningFromPremiumPlanPurchaseToday,
      Icon: IconCurrencyDollar,
    },
   
  ];

  return (
    <div className="userPage">
      <div>
        <div className="dashboardHeader primeHeader mb-3 p-0">
          <NewTitle
            dayAnalyticsShow={true}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            startDate={startDate}
            endDate={endDate}
            setMultiButtonSelect={handleMultiButtonSelect}
            multiButtonSelect={multiButtonSelect}
            labelData={["All Plan", "Coin Plan", "Premium Plan"]}
          />
        </div>
        <StatsCards cards={statsCards} />

        {multiButtonSelect === "All Plan" && (
          <AllPlanEarnings endDate={endDateData} startDate={startDateData} />
        )}

        {multiButtonSelect === "Premium Plan" && (
          <AdminEarnings
            endDate={endDateData}
            startDate={startDateData}
            multiButtonSelectNavigate={setMultiButtonSelect}
          />
        )}

        {multiButtonSelect === "Coin Plan" && (
          <CoinPlanEarnings
            endDate={endDateData}
            startDate={startDateData}
            multiButtonSelectNavigate={setMultiButtonSelect}
          />
        )}
      </div>
    </div>
  );
};

export default MainEarnings;
